import React, { useEffect, useState } from "react";
import { SERVE_FIRST_LOGO as image__powerby_serve } from "../constants/branding";
import { useIntl } from "react-intl";
import { postData } from "../components/FetchServices";
import {
  isServeFirstBrandingHidden,
  isServeFirstBrandingResolved,
  setServeFirstBrandingHidden,
} from "../helpers/serveFirstBranding";

function Footer(props) {
  const intl = useIntl();
  const companyId = localStorage.getItem("company_id");
  const [hideServeFirst, setHideServeFirst] = useState(
    isServeFirstBrandingHidden,
  );
  // Every employee-feedback page renders this footer, so the lookup lives here
  // to keep the branding correct on whichever page the visitor lands on first.
  const [brandResolved, setBrandResolved] = useState(
    () => isServeFirstBrandingResolved() || !companyId,
  );

  useEffect(() => {
    if (!companyId || isServeFirstBrandingResolved()) {
      return undefined;
    }

    let cancelled = false;

    const readBrandDetail = async () => {
      try {
        const result = await postData("api/getBrandDetail", {
          company_id: companyId,
        });
        if (!cancelled && result?.status === 200) {
          setHideServeFirst(
            setServeFirstBrandingHidden(result?.data?.hideServeFirst),
          );
        }
      } catch (e) {
        // Keep the last known branding state when the lookup fails.
      } finally {
        if (!cancelled) {
          setBrandResolved(true);
        }
      }
    };

    readBrandDetail();

    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return (
    <footer className="secondary-footer hide-sm">
      {brandResolved && !hideServeFirst ? (
        <div className="logo d-flex align-items-center justify-content-center">
          <span
            style={{
              marginRight: "15px",
              fontSize: "14px",
              color: "#FFF",
              fontWeight: "bold",
            }}
          >
            {intl.formatMessage({ id: "powered-by" })}
          </span>
          <img
            src={image__powerby_serve}
            alt="footer"
            style={{ height: "50px" }}
          />
        </div>
      ) : null}
    </footer>
  );
}
export default Footer;
